export const faqs = [
  {
    q: '¿Este sistema es realmente para principiantes?',
    a: [
      'El sistema está organizado en seis volúmenes que abordan los fundamentos del triatlón, sus tres disciplinas, la planificación, la nutrición y la estrategia de competición.',
      'Esto permite consultar el material de forma estructurada. La adecuación de cada contenido a tu nivel dependerá de tus necesidades y experiencia deportiva.',
    ],
  },
  {
    q: '¿Necesito un entrenador para utilizar el sistema?',
    a: [
      'El producto es un recurso digital de organización y formación. No es un servicio de entrenamiento individualizado ni sustituye la evaluación de un entrenador cualificado cuando necesitas orientación específica para tu condición física y tus objetivos.',
    ],
  },
  {
    q: '¿Necesito ir a un gimnasio?',
    a: [
      'El material se centra en la preparación para triatlón. Las necesidades de equipamiento dependerán de tus sesiones, tu planificación y las condiciones en las que entrenes.',
    ],
  },
  {
    q: '¿Es un libro físico?',
    a: ['No. SISTEMA TRIATLÓN COMPLETO™ es un producto digital en formato PDF. No se envía ningún libro físico.'],
  },
  {
    q: '¿Es un pago único?',
    a: [
      'Sí. El precio promocional indicado corresponde a un pago único por el producto digital, conforme a las condiciones mostradas en el proceso de compra.',
    ],
  },
  {
    q: '¿Cómo accedo al material?',
    a: ['Después de completar la compra, recibirás acceso digital al material según las instrucciones de entrega de la plataforma.'],
  },
  {
    q: '¿Incluye los cuatro bonos?',
    a: [
      'Sí. La oferta incluye los cuatro bonos complementarios descritos en esta página: Planificador de Entrenamiento de 12 Semanas™, Guía de Nutrición e Hidratación™, Checklist Definitivo del Triatleta™ y Registro de Rendimiento del Triatleta™.',
    ],
  },
  {
    q: '¿Puedo utilizarlo en Android y iOS?',
    a: [
      'El material está en formato PDF y puede consultarse desde dispositivos compatibles con este formato, incluidos teléfonos, tabletas y ordenadores.',
    ],
  },
  {
    q: '¿Es un servicio de entrenamiento personalizado?',
    a: [
      'No. SISTEMA TRIATLÓN COMPLETO™ es un producto digital de formación y organización. No incluye seguimiento individual, supervisión en tiempo real ni un plan personalizado elaborado a partir de una evaluación individual.',
    ],
  },
];

export const steps = [
  {
    n: '1',
    title: 'Descarga inmediata',
    body: 'Compra SISTEMA TRIATLÓN COMPLETO™ y accede al sistema digital de seis volúmenes junto con los cuatro bonos complementarios. Sin envíos físicos. Sin esperas por correo postal. Empieza cuando tengas todo listo.',
    tags: [] as string[],
    after: '',
  },
  {
    n: '2',
    title: 'Organiza tu sistema de entrenamiento',
    body: 'Trabaja con los seis volúmenes y organiza tu preparación contemplando:',
    tags: ['Natación', 'Ciclismo', 'Carrera', 'Fuerza complementaria', 'Recuperación', 'Nutrición', 'Seguimiento del progreso'],
    after: 'En lugar de preguntarte constantemente «¿qué debería hacer después?», dispondrás de una estructura de referencia para organizar tu preparación.',
  },
  {
    n: '3',
    title: 'Prepárate para tu competición',
    body: 'A medida que se acerque el día de la prueba, utiliza los recursos incluidos para organizar:',
    tags: ['Tu entrenamiento', 'Tu alimentación e hidratación', 'Tu seguimiento del progreso', 'Tu equipamiento', 'Tu semana de competición', 'Tu estrategia'],
    after: '',
  },
];
